<head>
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
</head>


<br> <br>
<button style="margin-left:95%" type="button" class="btn btn-warning btn-circle btn-lg" (click)="cancel()"><i
    class="fa fa-close"></i></button>

<div class="modal-body">
  <form #UpdpreForm="ngForm">
    <div class="form-group">
      <label for="sdate">Start date</label>
      <div class="input-group">
        <input class="form-control" placeholder="yyyy-mm-dd" name="sdate" [(ngModel)]='epresc.sdate' #sdate="ngModel"
          ngbDatepicker #dp="ngbDatepicker" [minDate]="minDate">
        <div class="input-group-append">
          <button class="btn btn-outline-secondary calendar" (click)="dp.toggle()" type="button"></button>
        </div>
      </div>
    </div>
    <div class="form-group">
      <label for="edate">End date</label>
      <div class="input-group">
        <input id="dateOfBirth" class="form-control" placeholder="yyyy-mm-dd" name="edate" [(ngModel)]='epresc.edate'
          #edate="ngModel" ngbDatepicker #e="ngbDatepicker">
        <div class="input-group-append">
          <button class="btn btn-outline-secondary calendar" (click)="e.toggle()" type="button"></button>
        </div>
      </div>
    </div>
    <div class="form-group">
      <label for="medname">Enter Medicine name</label>
      <div class="input-group">
        <input class="form-control" type="text" name="mname" [(ngModel)]='epresc.mname' #mname="ngModel">
      </div>
    </div>
    <div class="form-group">
      <label for="strofmed">Strength of Medicine</label>
      <div class="input-group">
        <input class="form-control" [(ngModel)]='epresc.strength' #strength="ngModel" type="text" name="strength"
          placeholder="mg/ml/tbsp">
      </div>
    </div>
    <div class="form-group">
      <label for="intfreq">Intake Frequency</label>
      <div class="input-group">
        <!-- <input class="form-control" [(ngModel)]='epresc.intakefreq' name="intakefreq" #intakefreq="ngModel"  type="text" name="intakefreq" > -->
        <select class="form-control w-20" id="myCheck" [(ngModel)]='epresc.intakefreq' name="intakefreq"
          #intakefreq="ngModel" [disabled]="checkBox[1].checked">
          <option selected value="For every 6 hours">6 Hours </option>
          <option value="For every 8 hours">8 Hours </option>
          <option value="For every 10 hours">10 Hours </option>
          <option value="For every 12 hours">12 Hours </option>
          <option value="Morning only">Morning</option>
          <option value="Afternoon only">Afternoon</option>
          <option value="Evening only">Evening</option>
          <option value="Night only">Night</option>
          <option value="Morning & Night only">Morning & Night</option>
          <option value="Morning, Afternoon & Night ">Morning, Afternoon & Night</option>
          <option value="Morning, Evening & Night">Morning, Evening & Night</option>
          <option value="Afternoon & Evening ">Afternoon & Evening </option>
          <option value="Evening & Night only ">Evening & Night</option>
        </select>
      </div>
    </div>
    <!-- <div class="form-group">
                    <label for="intfreq">Prescription Id</label>
                    <div class="input-group">
                      <input readonly class="form-control" [(ngModel)]="data.prid" #prid="ngModel" type="text" name="prid" >
                      
                    </div>
                  </div> -->

    <button [disabled]="!UpdpreForm.valid" class="btn primary-btn" type="button" name="submit"
      (click)="Save(UpdpreForm.value)" (click)="cancel()">Change Prescription</button>
  </form>
</div>